import { defineStore } from "pinia";
import { showError } from "src/utils/notify";
import { Platform } from "quasar";
export const useReceipts = defineStore("receipts", {
  state: () => ({
    receiptsList: [],
    loadReceipts: false,
  }),
  getters: {},
  actions: {
    async getReceiptsData(params) {
      try {
        let response = await this.$request.get(
          Platform.is.mobile
            ? this.apiEndpoints.RECEIPTS(params.page, params.per_page)
            : this.apiEndpoints.RECEIPTS_WEB(
                params.page,
                params.per_page,
                params.extraparam
              )
        );
        if (params.page == 1) {
          this.receiptsList = [];
          this.loadReceipts = false;
        }
        if (response.data) {
          Array.prototype.push.apply(this.receiptsList, response.data.items);
          this.receiptsList.sort((a, b) => {
            var dateA = new Date(a.sale_timestamp.replace(" ", "T")).getTime();
            var dateB = new Date(b.sale_timestamp.replace(" ", "T")).getTime();
            return dateA < dateB ? 1 : -1;
          });
          this.loadReceipts = true;
        }
        return response.data;
      } catch (error) {
        // console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    resetReceiptsData() {
      this.receiptsList = [];
      this.loadReceipts = false;
    },
    async getReceiptImage(id) {
      try {
        let data = await this.$request.get(this.apiEndpoints.RECEIPT_IMAGE(id));
        if (data.data && data.data.status) {
          return data.data;
        } else {
          return data.data;
        }
      } catch (error) {}
    },
    async hideReceipt(id) {
      try {
        let data = await this.$request.get(this.apiEndpoints.RECEIPT_HIDE(id));
        if (data.data && data.data.status) {
          return data.data;
        } else {
          return data.data;
        }
      } catch (error) {}
    },
  },
});
